import React from "react";
import TrailTable from "components/common/TrailTable/TrailTable";

interface Props {
  entityId: string | number;
}

const BannersTrailTab: React.FC<Props> = ({ entityId }) => {
  return <TrailTable entityType="bannerGroup" entityId={Number(entityId)} />;
};

export default BannersTrailTab;
